import { Heading } from '@hungryroot/ramen';
import styles from './BinaryButtonGroup.module.css';

type ButtonOptions<T extends number> = {
  label: string;
  value: T;
};

interface BinaryButtonGroupProps<T extends number> {
  className?: string;
  handleClick: (value: T) => void;
  buttonOptionsLeft: ButtonOptions<T>;
  buttonOptionsRight: ButtonOptions<T>;
  selected?: T | null;
}

interface ButtonProps<T extends number> {
  options: ButtonOptions<T>;
  handleClick: (value: T) => void;
  selected?: T | null;
}

export function BinaryButtonGroup<T extends number>(
  props: BinaryButtonGroupProps<T>
) {
  const {
    className,
    handleClick,
    buttonOptionsLeft,
    buttonOptionsRight,
    selected,
  } = props;

  const buttonProps = {
    handleClick,
    selected,
  };

  return (
    <div className={`${styles.container} ${className}`}>
      <Button {...buttonProps} options={buttonOptionsLeft} />
      <Button {...buttonProps} options={buttonOptionsRight} />
    </div>
  );
}

function Button<T extends number>({
  options,
  selected,
  handleClick,
}: ButtonProps<T>) {
  const { label, value } = options;
  return (
    <button
      className={value === selected ? styles['button-selected'] : styles.button}
      onClick={() => handleClick(value)}
      data-selected={selected === value}
    >
      <Heading variant="H6">{label}</Heading>
    </button>
  );
}
